import React from "react";

// Selettore "Invia a: Professionista / Cliente finale" condiviso dai flussi operativi.
export const RecipientPicker = ({ value, onChange, clientEmail, testIdPrefix = "send-to" }) => {
  const hasClient = !!(clientEmail || "").trim();
  const opts = [
    { v: "pro", label: "Professionista", disabled: false },
    { v: "client", label: "Cliente finale", disabled: !hasClient },
  ];
  return (
    <div className="space-y-1" data-testid={`${testIdPrefix}-picker`}>
      <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Invia a</div>
      <div className="flex flex-wrap gap-2">
        {opts.map((o) => (
          <label
            key={o.v}
            title={o.disabled ? "Nessuna email cliente inserita" : ""}
            className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border text-sm transition-colors ${
              o.disabled ? "opacity-50 cursor-not-allowed border-slate-200"
                : value === o.v ? "border-violet-500 bg-violet-50 text-violet-800 cursor-pointer"
                  : "border-slate-200 hover:bg-slate-50 cursor-pointer"
            }`}
            data-testid={`${testIdPrefix}-${o.v}`}
          >
            <input
              type="radio"
              name={`${testIdPrefix}-radio`}
              value={o.v}
              checked={value === o.v}
              disabled={o.disabled}
              onChange={() => onChange(o.v)}
              className="accent-violet-600"
              data-testid={`${testIdPrefix}-${o.v}-radio`}
            />
            {o.label}
          </label>
        ))}
      </div>
      {value === "client" && hasClient && (
        <div className="text-[11px] text-slate-500" data-testid={`${testIdPrefix}-client-email`}>
          Email cliente: <strong>{clientEmail}</strong>
        </div>
      )}
      {!hasClient && (
        <div className="text-[11px] text-slate-400" data-testid={`${testIdPrefix}-no-client-email`}>
          Nessuna email cliente inserita
        </div>
      )}
    </div>
  );
};
